"use client";

import { useEffect, useState } from "react";
import { useSession } from "next-auth/react";
import { useDispatch, useSelector } from "react-redux";
import { updateUserLocation } from "@/store/apps/userData/UserDataSlice";

export default function LocationUpdater() {
  const { data: session, status } = useSession();
  const dispatch = useDispatch();
  const [hasCheckedLocation, setHasCheckedLocation] = useState(false);

  const profile = useSelector((state) => state.user.profile);
  const hasFetched = useSelector((state) => state.user.hasFetched);
  const locationUpdatedThisSession = useSelector(
    (state) => state.user.locationUpdatedThisSession
  );
  const isLoading = useSelector((state) => state.loading.isLoading);

  useEffect(() => {
    if (
      status === "authenticated" &&
      session?.user?.sub &&
      hasFetched &&
      profile &&
      !hasCheckedLocation &&
      !isLoading &&
      !locationUpdatedThisSession
    ) {
      setHasCheckedLocation(true);

      const autoUpdateEnabled =
        profile?.preferences?.auto_update_location === true;

      // Only update if auto-update is specifically enabled
      // (fetchUserData already handles missing data)
      if (autoUpdateEnabled) {
        dispatch(updateUserLocation());
      }
    }
  }, [
    session,
    status,
    hasFetched,
    profile,
    locationUpdatedThisSession,
    isLoading,
    hasCheckedLocation,
    dispatch,
  ]);

  // Reset hasCheckedLocation when session changes (user logs out/in)
  useEffect(() => {
    if (status === "unauthenticated") {
      setHasCheckedLocation(false);
    }
  }, [status]);

  return null;
}
